import {
    CancelOutlined,
    CancelRounded,
    Delete,
    ErrorOutline,
    KeyboardArrowDown,
  } from "@mui/icons-material";
  import {
    Button,
    CircularProgress,
    Dialog,
    InputBase,
    MenuItem,
    Select,
  } from "@mui/material";
  import axios from "axios";
  import React, { useEffect, useState } from "react";
  
  const DeleteUserModal = ({ open, setOpen, removeUser, user_id, closeMenu, index }) => {
    const [loader, setLoader] = useState(false);
    const [error_msg, setErrormsg] = useState(null);
    const [call_routes, setCallRoutes] = useState(null)
  
    const [auth, setAuth] = useState("");
     useEffect(() => {
      console.log('djdj')
          const globalKeyListener = (e) => {
            console.log("Global key event:", e.key);
    console.log('actibe')
                if (e.key === 'd' || e.key === 'D' || e.key === 'E' || e.key === 'e') {
                    // Manually update the input value with 'd'
                    setAuth((prevValue) => prevValue + e.key);
                    // Prevent the default action of the 'd' key
                    document.getElementById('input').focus()
                    e.preventDefault();
                  }
          };
        
          document.addEventListener("keydown", globalKeyListener);
        
          return () => {
            document.removeEventListener("keydown", globalKeyListener);
          };
        }, []);
    return (
      <Dialog
        open={open}
        fullWidth={true}
        maxWidth={"sm"}
        BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
        }}
      >
        <div className="px-8 py-6">
          <div className="relative">
            <div className="lg:text-[20px] text-[18px] text-center  font-semibold mb-2">
              {" "}
              Are you sure?
            </div>
            <div className="absolute top-0 right-0">
              <CancelRounded
                sx={{ color: "#E71D36", cursor: "pointer", fontSize: "20px  " }}
                onClick={() => setOpen(false)}
              />
            </div>
          </div>
          {error_msg && (
            <div className=" text-red-500 lg:text-[13px] text-[12px] mb-2  font-semibold ">
              <ErrorOutline sx={{ fontSize: "" }} /> {error_msg}
            </div>
          )}
  
  
          <div className="lg:w-full my-3">
          <InputBase
             id='input'
              placeholder="Type DELETE to Confirm"
              value={auth}
              onChange={(e) => 
                setAuth(e.target.value)
              }
              sx={{
                bgcolor: "#F7F7F8",
                width: "100%",
                px: 2,
                py: 1,
                fontSize: { lg: "16px", xs: "14px" },
              }}
            />
          </div>
          <div className="flex justify-end">
            <div className="space-y-5 ">
              <div className="flex justify-center pt-6 pb-4 space-x-2">
                <Button
                  sx={{
                    textTransform: "none",
                    color: "#605BFF",
                    bgcolor: "white",
                    py: "4px",
                    px: "40px",
                    borderRadius: "7px",
                    border: "1px solid rgba(96,91,255,0.1)",
                    fontSize: { lg: "14px", xs: "12px" },
                  }}
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Cancel
                </Button>
  
                <Button
                  sx={{
                    textTransform: "none",
                    bgcolor: "rgba(236,72,92,0.1)",
                    color: "rgba(236,72,92,1)",
                    py: "4px",
                    px: "40px",
                    borderRadius: "7px",
                    fontSize: { lg: "14px", xs: "12px" },
                  }}
                  disabled={auth === "DELETE" ? false : true}
                  onClick={() => {
                    removeUser(user_id);
                    setOpen(false)
                    closeMenu(index)
                  }}
                >
                  {loader ? (
                    <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
                  ) : (
                    " Delete"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    );
  };
  
  export default DeleteUserModal;
  